module.exports = __webpack_public_path__ + "media/images/lesson_5/sebastiao_triste-e096102d30c0951b4845046cff578a1d.png";